import React, { Component } from "react";
import vignette from "../images/vignette.png";

//Avatars
import koala from "../images/koala.png";
import fox from "../images/fox.png";
import lemur from "../images/lemur.png";
import zebra from "../images/zebra.png";

export default class UIOverlay extends Component {
  constructor() {
    super();

    this.state = {
      cardIsOpen: true
    };

    this.openCard = this.openCard.bind(this);

    this.closeCard = this.closeCard.bind(this);
  }

  openCard() {
    this.setState({ cardIsOpen: true });
  }

  closeCard() {
    this.setState({ cardIsOpen: false });
  }

  render() {
    return (
      <div>
        <img src={vignette} alt="filter-effect" className="vignette" />

        <div className="Desktop-top-left">
          <div className="card UI-top-left">
            <div className="UI-top-left-text">
              <h2>
                {" "}
                Round{" "}
                <span style={{ color: "#52b452dc" }}>
                  {" "}
                  {this.props.whichRound}{" "}
                </span>
              </h2>
              <div className="UI-text-top-left">
                <p>Ooh nice place! Where could this be?</p>
              </div>
            </div>

            {/*<p className="Silly-text">You look beautiful today!</p>*/}
            <div>
              <img
                src={
                  localStorage.getItem("avatar") === "Koala"
                    ? koala
                    : localStorage.getItem("avatar") === "Fox"
                    ? fox
                    : localStorage.getItem("avatar") === "Lemur"
                    ? lemur
                    : localStorage.getItem("avatar") === "Zebra"
                    ? zebra
                    : koala
                }
                alt="Koala"
                width="75pt"
                height="auto"
              />
            </div>
          </div>
        </div>

        <div className="card UI-top-left-mobile">
          <div className="Koala-mobile">
            <img
              src={
                localStorage.getItem("avatar") === "Koala"
                  ? koala
                  : localStorage.getItem("avatar") === "Fox"
                  ? fox
                  : localStorage.getItem("avatar") === "Lemur"
                  ? lemur
                  : localStorage.getItem("avatar") === "Zebra"
                  ? zebra
                  : koala
              }
              alt="Koala"
              width="75pt"
              height="auto"
            />
          </div>
          <div className="UI-top-left-text">
            <h2>
              Round
              <span style={{ color: "#52b452dc" }}>
                {" "}
                {this.props.whichRound}{" "}
              </span>
            </h2>

            <h3>
              Total score:{""}
              <span style={{ color: "#52b452dc" }}>
                {""}
                &nbsp;{localStorage.getItem("totalscore")}
                {""}
              </span>
            </h3>
          </div>
        </div>

        {this.state.cardIsOpen ? (
          <button className="Questionmark-button-open" onClick={this.closeCard}>
            <span aria-hidden="true">?</span>
          </button>
        ) : (
          <div className="card info-overlay--after-click">
            <h1>Goal:</h1>
            <p>Find out where on Earth you are right now. </p>
            <br />
            <p style={{ textAlign: "left", fontWeight: "bold" }}>
              You can try:{" "}
            </p>
            <ul>
              <li>Look around the environment.</li>
              <li>Identify signs and languages.</li>
              <li>
                The closer you are when guessing the country the more points you
                get.
              </li>
            </ul>

            <br />

            <p style={{ fontWeight: "bold" }}>
              When you think you know the answer click the green button below!
            </p>

            <button className="cta-button" onClick={this.openCard}>
              Ok, got it!
            </button>
            <p>If something goes wrong click here:</p>
            <button className="cta-button" onClick={() => {
              this.openCard();
              this.props.goToEndScreen();
                }}>
              Ooops..
            </button>
          </div>

          /*
            <div className="UI-top-right-text">
              <h1>Goal:</h1>Find out where on Earth you are right now
              <div className="Instruction-text">
                <p>You can try: </p>
                <p> - Look around the environment </p>
                <p> - Identify signs and languages. </p>
              </div>
              <div className="Answer-instruction-text">
                When you think you know the answer, click the green button
                below!
              </div>
              </div>
        */
        )}

        <div className="card UI-bottom-left">
          <div className="ScoreBoard">
            <p>
              Total score{" "}
              <span style={{ color: "#52b452dc" }}>
                {" "}
                &nbsp; {localStorage.getItem("totalscore")}{" "}
              </span>
            </p>
          </div>
        </div>
        <div className="ready-to-answer">
          <button
            className="UI-bottom-right"
            disabled={this.props.continueScoreBoard}
            // disabled = {this.props.continueWelcomeLevelTwo}
            onClick={() => {
              if (this.props.whichModal === "two") {
                this.props.readyToAnswerCountry();
              } else if (this.props.whichModal === "one") {
                this.props.readyToAnswer();
              }
            }}
          >
            I am ready to answer
          </button>
        </div>
      </div>
    );
  }
}
